import styled from 'styled-components';

const ModalWrapper = styled.div`
	position: relative;
	display: inline-block;
`;

export default ModalWrapper;
